import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { updateMatCancel } from "../api/matAPI";

const EditCancellation = (props) => {
    const [cancellationDetails, setCancellationDetails] = useState({});

    useEffect(() => {
        $('#edit-Cancellation-modal').modal({ backdrop: 'static' });
        $('#edit-Cancellation-modal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');   
            props.onDismissModal(null); 
        });
    }, []);

    useEffect(() => {
        if (props.cancellationDetails) {
            setCancellationDetails({ ...props.cancellationDetails });
        }
    }, [props.cancellationDetails]);

    const updateCancellationDetails = (field, value) => { 
        setCancellationDetails((prev) => ({ ...prev, [field]: value }));
    };

    const submitCancellation = async (e) => {
        e.preventDefault()

        var form = $('#cancellationForm');
        
        form.validate({
            rules: {
                txtRefNo: {
                    required: true,
                },
                txtRefAmount: {
                    required: true,
                }                         
            },
            messages: {
                txtRefNo: {
                    required: "Please enter Ref No"
                },
                txtRefAmount: {
                    required: "Please enter Ref Amount"
                }
            }
        });
        if (!form.valid()) return;
        try {
            await updateMatCancel({ID: cancellationDetails.ID, RefundRefNo: cancellationDetails.RefundRefNo, RefundAmount: cancellationDetails.RefundAmount , RefundComment: cancellationDetails.RefundComment})
            swal.fire({
                icon: 'success',
                titleText: 'Cancellation updated successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
            setCancellationDetails({})
            $('#edit-Cancellation-modal').modal('hide');
            
        } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return
        } 
        props.refetchData();
        form.clearForm();
        form.validate().resetForm();
    };

    return (
        <div className="modal fade" id="edit-Cancellation-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Cancel Booking</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form id="cancellationForm">
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Date</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" value={cancellationDetails.CancelDate || ''} disabled />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Slot</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" disabled value={`${cancellationDetails.SlotFrom} - ${cancellationDetails.SlotTo}` || ''} readOnly />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Type</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" disabled value={cancellationDetails.TypeName || ''} readOnly />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Number</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" disabled value={cancellationDetails.MatNumber || ''} readOnly />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">User Comment</label>
                                <div className="col-6">
                                    <textarea className="form-control" rows="2" disabled value={cancellationDetails.txtUserComment || ''}  ></textarea>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Refund Ref No <span className="red">*</span></label>
                                <div className="col-6">
                                    <input type="text" className="form-control" id="txtRefNo" name="txtRefNo" value={cancellationDetails.RefundRefNo || ''} onChange={(e) => updateCancellationDetails('RefundRefNo', e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Refund Amount <span className="red">*</span></label>
                                <div className="col-6">
                                    <input type="text" className="form-control"  id="txtRefAmount" name="txtRefAmount" value={cancellationDetails.RefundAmount || ''} onChange={(e) => updateCancellationDetails('RefundAmount', e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Comment</label>
                                <div className="col-6">
                                    <textarea className="form-control" rows="2" value={cancellationDetails.RefundComment || ''} onChange={(e) => updateCancellationDetails('RefundComment', e.target.value)}></textarea>
                                </div>
                            </div>
                        </form>
                        <table id="table-user" className="table table-bordered table-hover margin-b30">
                            <thead className="light-grey-background">
                                <tr>
                                    <th>Players</th>
                                    <th>Category</th>
                                    <th>Bucket</th>
                                    <th className="text-center">Club</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <span className={`kt-badge kt-badge--${cancellationDetails.UserType == "User" ? 'success' : (cancellationDetails.UserType == "Guest" || cancellationDetails.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}>
                                        </span>&nbsp; &nbsp;{cancellationDetails.Player}&nbsp; &nbsp;
                                        <small style={{color: "Red"}}>{(cancellationDetails.IsSubscriptionExpires == "N" && cancellationDetails.IsValidMember == "N") ? "Subscription Expired!" : ''}</small>
                                    </td>
                                    <td> 
                                        {cancellationDetails.SubCategoryName}
                                    </td>
                                    <td> 
                                        {cancellationDetails.Bucket}
                                    </td>
                                    <td> 
                                        {cancellationDetails.Club == 0 ? "No" : "Yes"}
                                    </td>
                                </tr>
                            </tbody> 
                        </table>
                        <table id="table-tax" className="table table-bordered table-hover margin-b30" style={{ flex: 1   }}>
                                <thead className="light-grey-background">
                                    <tr>
                                        <th>Description</th>
                                        <th className="text-right">Amount (₹)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cancellationDetails.TotalMatFee != 0 && (
                                    <tr>
                                        <td>Green Fee </td>
                                        <td className="text-right">₹ {cancellationDetails.TotalMatFee}</td>
                                    </tr>   
                                    )} 
                                    {cancellationDetails.TotalBucketFee != 0 && (
                                        <tr>
                                        <td>{cancellationDetails.Bucket + ' Bucket'} </td>
                                        <td className="text-right">₹ {cancellationDetails.TotalBucketFee}</td>
                                    </tr>    
                                    )} 
                                    {cancellationDetails?.Club == 1 && (
                                        <tr>
                                            <td>Club</td>
                                            <td className="text-right">₹ {cancellationDetails.TotalClubFee}</td>
                                        </tr>
                                    )}
                                    {cancellationDetails.Discount != 0 && (
                                        <tr>
                                            <td>Discount</td>
                                            <td className="text-right">- ₹ {cancellationDetails?.Discount}</td>
                                        </tr>
                                    )}
                                        <tr>
                                        <td>SGST (9%)</td>
                                        <td className="text-right">₹ {cancellationDetails.Sgst}</td>
                                    </tr>
                                    <tr>
                                        <td>CGST (9%)</td>
                                        <td className="text-right">₹ {cancellationDetails.Cgst}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Total</strong></td>
                                        <td className="text-right"><strong>₹ {cancellationDetails.FinalAmount}</strong></td>
                                    </tr>
                                </tbody>
                                <tfoot></tfoot>
                        </table>
                    </div>
                    <div className="modal-footer" style={{marginLeft: 'auto'}}>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-info" onClick={submitCancellation}>Process Refund</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCancellation;
